import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { applyOptIn, applyOptInOutManager, applyOptOut } from ".";
import { ready } from "../../utils";
/**
 * Apply cookies on frontend. Depending on some other mechanism you can differ
 * between the following "decision" types:
 *
 * - `all`: All cookies are applied (e. g. bots)
 * - `consent`: All cookies from the current consent (read from cookie)
 *
 * The cookies are sent in the following way:
 *
 * 1. Apply opt-in scripts (sequentially)
 * 2. If GTM / MTM is active, wait for the data layer
 *   a) Push all opt-in events (parallel)
 *   b) Wait x seconds to avoid side effects
 *   c) Push all opt-out events (parallel)
 * 3. Apply opt-in scripts (sequentially)
 *
 * @param type
 * @see https://www.simoahava.com/analytics/notify-page-google-tag-manager-loaded/
 * @see https://support.google.com/tagmanager/answer/7679219
 * @see https://developer.matomo.org/guides/tagmanager/datalayer
 */

function applyCookies(_x) {
  return _applyCookies.apply(this, arguments);
}

function _applyCookies() {
  _applyCookies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type) {
    var _yield$applyOptIn, dataLayerPromise, isManagerOptOut;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return ready();

          case 2:
            _context.next = 4;
            return applyOptIn(type);

          case 4:
            _yield$applyOptIn = _context.sent;
            dataLayerPromise = _yield$applyOptIn.dataLayerPromise;
            isManagerOptOut = _yield$applyOptIn.isManagerOptOut;
            _context.t0 = applyOptInOutManager;
            _context.t1 = type;
            _context.next = 11;
            return dataLayerPromise;

          case 11:
            _context.t2 = _context.sent;
            _context.t3 = isManagerOptOut;
            _context.next = 15;
            return (0, _context.t0)(_context.t1, _context.t2, _context.t3);

          case 15:
            _context.next = 17;
            return applyOptOut(type, isManagerOptOut);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _applyCookies.apply(this, arguments);
}

export { applyCookies };